import { render, staticRenderFns } from "./RelateEvaluationList.vue?vue&type=template&id=136a0e8a"
import script from "./RelateEvaluationList.vue?vue&type=script&lang=js"
export * from "./RelateEvaluationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports